<template>
    <div class="effectiveTime">
        <div class="li">
            <div class="label">时间选择：</div>
            <div class="infos">
                <div class="item">
                    <div class="yuan" :class="{ 'yuan-ed': efficientProperty == '0' }"
                        @click="efficientPropertyChange('0')"></div>
                    <div class="txt">全天</div>
                </div>
                <div class="item">
                    <div class="yuan" :class="{ 'yuan-ed': efficientProperty == '1' }"
                        @click="efficientPropertyChange('1')"></div>
                    <div class="txt">指定时间段</div>
                </div>
                <template v-if="efficientProperty == '1'">
                    <div class="time-view">
                        <el-time-picker v-model="startTime" format="HH:mm" placeholder="开始时间" value-format="HH:mm" @change="startTimeChange">
                        </el-time-picker>
                    </div>
                    <div class="line">-</div>
                    <div class="time-view">
                        <el-time-picker v-model="endTime" format="HH:mm" placeholder="结束时间" value-format="HH:mm">
                        </el-time-picker>
                    </div>
                </template>

            </div>
        </div>
        <div class="li">
            <div class="label">重复方式：</div>
            <div class="infos">
                <div class="item" v-for="(item, index) in timingTypeList" :key="index">
                    <div class="yuan" :class="{ 'yuan-ed': efficientType == item.dictValue }"
                        @click="efficientTypeChange(item.dictValue)"></div>
                    <div class="txt">{{ item.dictLabel }}</div>
                </div>

            </div>
        </div>
        <div class="weeekList" v-if="efficientType == '4'">
            <div class="item " :class="{ 'item-ed': weektypeArr.includes(item.dictValue) }"
                v-for="(item, index) in weekTypeList" :key="index" @click="weekClick(item.dictValue)">
                <div class="txt">{{ item.dictLabel }}</div>
                <div class="r-g">
                    <img class="icon" src="@/assets/image/cloudscene/mti.png" alt="">
                </div>
            </div>
        </div>
        <div class="split"></div>
        <div class="li">
            <div class="label">场景名称：</div>
            <div class="input">
                <el-input v-model="sceneName" placeholder="请输入内容" maxlength="100"></el-input>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["timingTypeList", "weekTypeList", "triggerList", "movementList"],
    data() {
        return {
            efficientProperty: "",//0:全天1:指定
            startTime: "",
            endTime: "",
            efficientType: "",
            weektypeArr: [],
            sceneName: "",
        }
    },
    methods: {
        efficientPropertyChange(value) {
            this.efficientProperty = value
        },
        efficientTypeChange(value) {
            this.efficientType = value;
        },
        // 自定义星期选择
        weekClick(value) {
            let bool = this.weektypeArr.indexOf(value) !== -1;
            if (!bool) {
                this.weektypeArr.push(value);
            } else {
                this.weektypeArr.splice(this.weektypeArr.indexOf(value), 1);
            }
            if (this.weektypeArr.length == 7) {
                this.efficientType = "1"
                this.weektypeArr = []
            }
        },
        // 初始化数值
        initPage(params) {
            this.efficientProperty = ""
            this.startTime = ""
            this.endTime = ""
            this.efficientType = ""
            this.weektypeArr = []
            this.sceneName = ""
            if (params.efficientProperty) {
                this.efficientProperty = params.efficientProperty
            }
            if (params.efficientType) {
                this.efficientType = params.efficientType
            }
            if (params.efficientData.startTime) {
                this.startTime = params.efficientData.startTime
            }
            if (params.efficientData.endTime) {
                this.endTime = params.efficientData.endTime
            }
            if (params.efficientData.type) {
                this.weektypeArr = params.efficientData.type.split(",")
            }
            if (params.sceneName) {
                this.sceneName = params.sceneName
            }
            this.namePopupOpen();
        },
        namePopupOpen() {
            this.sceneName = this.triggerList[0].name;
            if (this.triggerList.length > 1) {
                this.sceneName += "等" + this.triggerList.length + "个条件"
            }
            // this.dialogName += "-"+this.movementList[0].name +this.movementList[0].operationName;
            this.sceneName += "-" + this.movementList[0].propertyName
            if (this.movementList.length > 1) {
                this.sceneName += "等" + this.movementList.length + "个操作"
            }
            if (this.sceneName.length > 100) {
                this.sceneName = this.sceneName.slice(0, 100)
            }
        },
        submitYZ() {
            let res = {
                code: null,
                msg: null
            }
            if (!this.efficientProperty.length) {
                res.code = 500;
                res.msg = "请选择生效时间"
                return res;
            }
            if (this.efficientProperty == "1") {
                if (this.startTime == "" || this.endTime == "") {
                    res.code = 500;
                    res.msg = "请选择生效时间段"
                    return res;
                }
            }
            if (!this.efficientType.length) {
                res.code = 500;
                res.msg = "请选择重复方式"
                return res;
            }
            if (this.efficientType == "4" && !this.weektypeArr.length) {
                res.code = 500;
                res.msg = "请选择自定义周期"
                return res;
            }
            if (!this.sceneName.length) {
                res.code = 500;
                res.msg = "请输入场景名称"
                return res;
            }
            res.code = 200;
            this.submitClick();
            return res
        },
        submitClick() {
            let params = {
                efficientProperty: this.efficientProperty,
                efficientType: this.efficientType,
                efficientData: {
                    startTime: this.startTime,
                    endTime: this.endTime,
                    type: this.weektypeArr.join(","),
                },
                sceneName: this.sceneName
            }
            this.$emit("effectiveTimeEmitFun", params)
        },
        // 开始时间选择后
        startTimeChange() {
            console.log(this.endTime);
            
            if(!this.endTime) {
                this.endTime = this.addOneHour(this.startTime)
            }
        },
        addOneHour(time) {
		    // 分割时间字符串为小时和分钟
		    let [hour, minute] = time.split(':').map(Number);
		    // 增加1小时
		    hour += 1;
		    // 如果小时超过23，重置为0
		    if (hour === 24) {
		        hour = 0;
		    }
		    // 保证分钟部分不会改变
		    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
		},
    },
}
</script>

<style lang="scss" scoped>
.effectiveTime {
    text-align: left;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: .3rem;

    .yuan {
        cursor: pointer;
        position: relative;
        width: .2rem;
        height: .2rem;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 50%;
        border: 1px solid #DBDBDB;
    }

    .yuan-ed {
        border-color: #2DAEA9;

        &::after {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            content: "";
            width: 0.1rem;
            height: .1rem;
            background: #2daea9;
            border-radius: 50%;

        }
    }

    .li {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        display: flex;
        align-items: center;
        margin-bottom: .175rem;
        height: .5rem;

        .label {
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
        }

        .infos {
            display: flex;
            align-items: center;

            .item {
                width: 2rem;
                display: flex;
                align-items: center;


                .txt {
                    margin-left: .1375rem;
                }
            }

            .time-view {
                width: 2.4375rem;

                .el-date-editor.el-input,
                .el-date-editor.el-input__inner {
                    width: 100%;
                }
            }

            .line {
                margin: 0 .2rem;
            }

        }

        .input {
            width: 4rem;
        }
    }


    .weeekList {
        width: 764px;
        height: 77px;
        border-radius: 6px;
        border: 1px solid #EEEEEE;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 .3rem;

        .item {
            user-select: none;
            cursor: pointer;
            width: .8875rem;
            height: .3375rem;
            border-radius: 5px;
            border: 1px solid #E5E5E5;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            overflow: hidden;

            .txt {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #454545;
                padding-left: .075rem;
                padding-right: .075rem;
            }

            .r-g {
                flex: 1;
                height: 100%;
                border-left: 1px solid #E5E5E5;
                background: #fafafa;
                display: flex;
                align-items: center;
                justify-content: center;

                .icon {
                    width: .2rem;
                    height: .2rem;
                    display: none;
                }
            }
        }

        .item-ed {
            border-color: #42B5B2;

            .r-g {
                border-color: #42B5B2;

                .icon {
                    display: block;
                }
            }
        }

        .item-no {
            cursor: not-allowed;
            pointer-events: none;
        }
    }

    .split {
        margin-top: .5rem;
        margin-bottom: .475rem;
        height: 1px;
        background: #EEEEEE;
    }
}
</style>